import React, { useEffect } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import DigitalDownload from "./DigitalDownload";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../hooks/usedTypedSelector";
import { getDigital } from "../../../features/middleware/digitalMiddleware";

const DigitalEng = () => {
  // card hover effect object
  const cardHover = {
    boxShadow:
      "rgba(0, 0, 0, 0.05) 4px 4px 26px 5px, rgba(0, 0, 0, 0.02) 6px 8px 26px 0px",
    transform: "translate(0px, -10px)",
    cursor: "pointer",
  };
  // redux dispatch func to fetch data from middleware asyncthunk
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getDigital());
  }, [dispatch]);
  const { loading, dataDigital } = useAppSelector(
    (state) => state.digitalSlice
  );
  return (
    <section id="digitalEng" style={{ backgroundColor: "#fafbff" }}>
      <Container
        maxWidth="lg"
        sx={{ padding: { xs: "40px 0", sm: "40px 0", md: "130px 0 0" } }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={12} md={12}>
              <Typography
                variant="h3"
                sx={{
                  textAlign: { xs: "center", sm: "center", md: "left" },
                  pb: 4,
                }}
              >
                Our Perspective on{" "}
                <span className="highlight-head">Digital Engineering</span>
              </Typography>
            </Grid>
            {loading && (
              <Grid item xs={12} md={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              </Grid>
            )}
          </Grid>
          <Grid container spacing={4}>
            {dataDigital &&
              dataDigital.map((cardItem, i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <Card
                    sx={{
                      maxWidth: "100%",
                      boxShadow:
                        "rgba(0, 0, 0, 0.05) 0px 1px 18px 0px, rgba(0, 0, 0, 0.07) 0px 3px 5px -1px",
                      transition: "all 0.4s ease 0s",
                      borderRadius: 0,
                      "&:hover": cardHover,
                    }}
                  >
                    <CardMedia
                      component="img"
                      alt="perspective image"
                      height="190"
                      image={cardItem.img}
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h6" component="div">
                        {cardItem.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {cardItem.description.slice(0, 80)}
                      </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: "space-between" }}>
                      <Button
                        size="small"
                        sx={{
                          color: "rgb(239, 83, 102)",
                          fontWeight: "400",
                          fontSize: "12px",
                          lineHeight: "13px",
                          fontFamily: "GraphikRegular",
                          textTransform: "capitalize",
                        }}
                      >
                        By {cardItem.author}
                      </Button>
                      <Button
                        size="small"
                        sx={{
                          color: "rgb(239, 83, 102)",
                          fontWeight: "400",
                          fontSize: "12px",
                          lineHeight: "13px",
                          fontFamily: "GraphikRegular",
                          textTransform: "capitalize",
                        }}
                      >
                        {cardItem.date}
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </Box>
      </Container>
      <DigitalDownload />
    </section>
  );
};

export default DigitalEng;
